import React from "react";
import PropTypes from "prop-types";
import { appAlert } from "../withOver";
import { SearchForm } from "./views/searchform/SearchForm";
import { FluxRecordSourceTreeGridLayout } from "./views/recordsourcetreegrid/RecordSourceTreeGridLayoutJS";
import Dispatcher from "Dispatcher";
import MappingStore from "data/MappingStore";
import { getMappingPlugins } from "data/selectors/entities";
import { getActiveRecord } from "data/selectors/records";
import NavigatorStore from "data/NavigatorStore";
import TableStore from "data/TableStore";
import DrawerLayoutJS from "lib/common/drawer/DrawerLayoutJS";
import LoadObject from "data/LoadObject";
import AdtStore from "data/AdtStore";
import HemoStore from "data/HemoStore";
import EcmoEmrStore from "data/EcmoEmrStore";
import MappingInfoStore from "data/meta/MappingInfoStore";
import TreeItemStore from "data/TreeItemStore";
import SearchResultStore from "data/SearchResultStore";
import MapDialogActions from "data/MapDialogActions";
import useFluxStore from "@armus/use-flux-store";

export function MappingModule(props) {
    const { onImport, onCancel, fluxContext } = props;
    const {
        layout,
        searchForm,
        body,
    } = useFluxStore(prevState => {
        let plugins;
        if (prevState == null) {
            const activeRecord = getActiveRecord(
                TableStore,
                NavigatorStore.getRecordState(fluxContext),
            );
            plugins = getMappingPlugins(activeRecord, fluxContext);
            plugins.forEach(p => {
                p.loadFields();
                p.deriveDefaultValuesFromActiveRecord();
            });
        } else {
            plugins = prevState.plugins;
        }
        const mapState = MappingStore.getState();
        const pluginKey = mapState.pluginKey;
        const plugin = plugins.find(p =>
            p.get("id") === pluginKey);
        const state = {
            plugins,
            layout: {
                enabled: mapState.source != null,
                open: mapState.drawerOpen,
                onToggle: () => {
                    Dispatcher.dispatch({
                        type: MapDialogActions.TOGGLE_DRAWER,
                    });
                },
            },
            searchForm: {
                typeOptions: plugins.map(it => ({
                    value: it.get("id"),
                    label: it.get("name"),
                })),
                resultsLO: plugin == null
                    ? LoadObject.empty()
                    : plugin.searchInteractive(),
                onSelectSource: pluginKey => {
                    Dispatcher.dispatch({
                        type: MapDialogActions.SELECT_PLUGIN,
                        key: pluginKey,
                    });
                },
                onPage: (page) => {
                    Dispatcher.contextDispatch(plugin.get("fluxContext"), {
                        type: MapDialogActions.SELECT_PAGE,
                        page,
                    });
                    plugin.searchInteractive(true);
                },
                onSearch: () => {
                    if (!plugin.validate()) {
                        appAlert("Search requires at least one criterion.");
                        return;
                    }
                    plugin.searchInteractive(true);
                },
                onSelectSourceRecord: source => {
                    Dispatcher.dispatch({
                        type: MapDialogActions.SELECT_SOURCE,
                        source,
                    });
                },
            },
        };
        if (plugin != null) {
            state.searchForm.fields = plugin.get("fields");
            state.searchForm.fluxContext = plugin.get("fluxContext");
            state.searchForm.resultLabeler = plugin.getLabelForResult;
            state.searchForm.hasPagination = plugin.hasPaginationParams();
            state.searchForm.pagination = plugin.searchPaginationResult();
        }
        if (mapState.source) {
            const ctx = fluxContext + ":mapping";
            state.body = {
                onImport: onImport,
                onCancel: onCancel,
                // for TreeStore
                ctx,
                isKeyExpanded: TreeItemStore.getExpandedTest(ctx),
            };
        }
        return state;
    }, [
        // these are _used_, but the app guarantees they can't change
        // TableStore,
        // NavigatorStore,
        MappingStore,
        AdtStore,
        HemoStore,
        EcmoEmrStore,
        MappingInfoStore,
        TreeItemStore,
        SearchResultStore, // for global lists...
    ], [ fluxContext, onImport, onCancel ]);
    return <DrawerLayoutJS
        enabled={layout.enabled}
        open={!layout.enabled || layout.open}
        onDrawerToggle={layout.onToggle}
        drawerContent={<SearchForm {...searchForm} />}
        content={body && <FluxRecordSourceTreeGridLayout {...body} />}
    />;
}


MappingModule.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    onImport: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default MappingModule;



// WEBPACK FOOTER //
// ./app/lib/mapping/MappingModule.js